import * as Yup from 'yup';

const instagramSchema = {
  instagram: Yup.string().required(
    'We use your Instagram account to know you have a good social presence and high quality images.'
  ),
};

export default function externalLinksSchema(isVenueSupplier) {
  return Yup.object().shape({
    supplier: Yup.object().shape({
      external_links: Yup.object().shape({
        website: Yup.string().required(
          "By giving us a website we can see your previous work in events and shows you're an established business."
        ),
        ...(!isVenueSupplier && instagramSchema),
      }),
    }),
  });
}
